(() => {
  const key = 'ppt_recently_viewed_v1';
  const validHandle = value => typeof value === 'string' && /^[a-z0-9][a-z0-9-]*$/i.test(value);
  let handles = [];
  try {
    const stored = JSON.parse(localStorage.getItem(key) || '[]');
    if (Array.isArray(stored)) handles = [...new Set(stored.filter(validHandle))].slice(0, 10);
  } catch (_) { /* Browsing still works when storage is unavailable. */ }
  const current = document.querySelector('[data-recent-product]')?.dataset.recentProduct;
  if (validHandle(current)) {
    handles = [current, ...handles.filter(handle => handle !== current)].slice(0, 10);
    try { localStorage.setItem(key, JSON.stringify(handles)); } catch (_) {}
  }
  const sections = [...document.querySelectorAll('[data-recently-viewed]')];
  if (!sections.length || !handles.length) return;

  // Render the real Shopify card: current prices, availability and variants,
  // not a price snapshot kept in the visitor's browser.
  const root = window.Shopify?.routes?.root || '/';
  Promise.all(handles.slice(0, 5).map(async handle => {
    try {
      const response = await fetch(root + 'products/' + encodeURIComponent(handle) + '?section_id=recently-viewed-product');
      if (!response.ok) return null;
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      const card = page.querySelector('[data-recent-product-card]');
      if (!card) return null;
      card.querySelectorAll('script:not([type="application/json"])').forEach(script => script.remove());
      return card;
    } catch (_) { return null; }
  })).then(cards => {
    const available = cards.filter(Boolean);
    if (!available.length) return;
    sections.forEach((section, sectionIndex) => {
      const list = section.querySelector('[data-recently-viewed-products]');
      if (!list) return;
      available.forEach(card => {
        const clone = card.cloneNode(true);
        clone.querySelectorAll('form[id]').forEach(form => {
          // Inputs named "id" can shadow HTMLFormElement.id in the browser.
          form.setAttribute('id', form.getAttribute('id') + '--recent-' + sectionIndex);
        });
        list.appendChild(clone);
      });
      section.hidden = false;
      document.dispatchEvent(new CustomEvent('ppt:products-loaded', { detail: { root: section } }));
    });
  });
})();
